import {Sequence} from 'components/Sequence';
import {PolymerTabState, PolymerTabStateAttributes} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

interface AnnotationsTableTabStateDefaults extends PolymerTabStateAttributes<Sequence> {
  showPartAnnotations: boolean;
}

class AnnotationsTableTabState extends PolymerTabState<Sequence> {
  defaults(): TabStateDefaults & Partial<AnnotationsTableTabStateDefaults> {
    return {
      ...super.defaults(),
      showPartAnnotations: false,
    };
  }

  initialize(attributes?: {analysis: Backbone.Model; sequence: Sequence}): void {
    super.initialize(attributes);
    this.set('title', 'Annotations');
  }
}

export default AnnotationsTableTabState;
